import React, { Component } from "react";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

import CategorySelection from "../categories/category_selection";

import TextareaAutosize from "react-textarea-autosize";

let strings = new LocalizedStrings({ en });

class CreateQuestionTextArea extends Component {
  render() {
    return (
      // <div className="question_answer_v2 center width_100">
      //   <div className="question_v2 ">
      <div className="question_v2" style={{ paddingBottom: "10px" }}>
        <TextareaAutosize
          placeholder={strings.create_question}
          type="text"
          className="question_title_v2 center"
          onChange={this.props.questionChanged}
          value={this.props.question}
          style={{
            width: "95%",
            backgroundColor: "transparent",
            border: "none"
          }}
        />
        <label className="question_asked_v2">
          Question asked by <span>@{this.props.user.username}</span>
        </label>
        <CategorySelection
          selectCategory={this.props.selectCategory}
          categories={this.props.categories}
          category={this.props.category}
        />
      </div>
      //   </div>
      // </div>
    );
  }
}

export default CreateQuestionTextArea;



// WEBPACK FOOTER //
// ./src/components/create_question/create_question.jsx